import { render, staticRenderFns } from "./SenderDomainsConfig.vue?vue&type=template&id=43862382&"
import script from "./SenderDomainsConfig.vue?vue&type=script&lang=js&"
export * from "./SenderDomainsConfig.vue?vue&type=script&lang=js&"
import style0 from "./SenderDomainsConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports